(function () {
  // Flag para evitar conflitos
  let isUpsellProcessing = false;
  // Timers compartilhados com setUpsellProcessing para que possamos
  // cancelar refreshes pendentes (de mutações que aconteceram ANTES
  // da supressão começar — ex: cart-items.js renderizando line-items).
  let drawerTimer = null;
  let pageTimer = null;

  // PERF: cache do último HTML do upsell pra evitar replaceWith desnecessário
  // (que causa reflow + flicker visual mesmo quando o conteúdo é idêntico).
  let lastDrawerUpsellHTML = null;
  let lastPageUpsellHTML = null;

  // RANDOM CROSSELL (2026-05-05): ordem do shuffle persiste durante a sessao
  // de pagina. Sem persistencia, cada re-fetch (mutation observer apos add/
  // remove de produto) re-embaralharia, e os primeiros N produtos visiveis
  // mudariam toda vez que o usuario interage com o carrinho. Com persistencia,
  // a ordem e congelada no primeiro render e reaplicada apos cada replaceWith.
  // Apenas o F5 (ou nova tab) gera nova ordem.
  let upsellShuffleOrder = null;

  function shuffleUpsellPool(scopeEl) {
    const root = scopeEl || document;
    const lists = root.querySelectorAll(
      '.cart-drawer-upsell-list[data-upsell-random="true"]'
    );
    if (!lists.length) return;

    lists.forEach((list) => {
      // DEDUP: quando o pool vem de multiplas colecoes (settings.random_collections),
      // o mesmo produto pode aparecer N vezes se estiver em N colecoes selecionadas.
      // Remove duplicatas do DOM antes de shuffle pra nao mostrar produto repetido.
      const allItems = Array.from(list.querySelectorAll(':scope > li[data-product-id]'));
      const seenIds = new Set();
      const items = [];
      allItems.forEach((li) => {
        const id = li.getAttribute('data-product-id');
        if (seenIds.has(id)) {
          li.remove();
          return;
        }
        seenIds.add(id);
        items.push(li);
      });
      if (items.length === 0) {
        list.setAttribute('data-shuffle-ready', '');
        return;
      }

      // Primeira execucao: gera ordem persistida.
      // CYGNUSS 2026-05-20 (v2): round-robin justo lendo data-collection-handle
      // direto de cada <li> e data-upsell-collection-order do <ul>. Antes usava
      // window.cyUpsellCollectionMap injetado via <script>, mas scripts NAO
      // executam quando o HTML vem por innerHTML/XHR (cart re-render), entao
      // a ordem ficava congelada/perdida. Atributos sobrevivem a re-renders.
      // Round-robin garante que cada colecao aparece em >=1 slot visivel
      // quando visibleCount >= bucketCount (corrige Sutias sumindo do v31).
      const fisherYates = (arr) => {
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
        }
        return arr;
      };

      if (!upsellShuffleOrder) {
        let shuffled;
        const DBG = '[cu-rotation]';
        try {
          const fairRotation = list.getAttribute('data-upsell-fair-rotation') === 'true';
          const orderAttr = list.getAttribute('data-upsell-collection-order') || '';
          const collectionOrder = orderAttr
            ? orderAttr.split(',').map((s) => s.trim()).filter(Boolean)
            : [];

          // DEBUG: estado bruto do que chegou no DOM
          try {
            const handleCounts = {};
            let missing = 0;
            items.forEach((li) => {
              const h = li.getAttribute('data-collection-handle') || '';
              if (!h) missing++;
              else handleCounts[h] = (handleCounts[h] || 0) + 1;
            });
            console.log(DBG, 'items=' + items.length,
              'fairRotation=' + fairRotation,
              'orderAttr="' + orderAttr + '"',
              'collectionOrder=' + JSON.stringify(collectionOrder),
              'handleCounts=' + JSON.stringify(handleCounts),
              'missingHandle=' + missing);
          } catch (_e) { /* noop */ }

          if (fairRotation && collectionOrder.length >= 2) {
            const buckets = new Map();
            collectionOrder.forEach((h) => buckets.set(h, []));
            const orphans = [];
            items.forEach((li) => {
              const handle = li.getAttribute('data-collection-handle') || '';
              if (handle && buckets.has(handle)) buckets.get(handle).push(li);
              else orphans.push(li);
            });
            buckets.forEach((arr) => fisherYates(arr));
            fisherYates(orphans);
            // DEBUG: tamanho de cada bucket apos fisher-yates
            try {
              const bucketSizes = {};
              buckets.forEach((arr, h) => { bucketSizes[h] = arr.length; });
              console.log(DBG, 'bucketSizes=' + JSON.stringify(bucketSizes),
                'orphans=' + orphans.length);
            } catch (_e) { /* noop */ }
            // Intercala round-robin: col1[0], col2[0], col3[0], col1[1], ...
            const interleaved = [];
            let added = true;
            let idx = 0;
            while (added) {
              added = false;
              for (const handle of collectionOrder) {
                const arr = buckets.get(handle);
                if (arr && arr[idx]) {
                  interleaved.push(arr[idx]);
                  added = true;
                }
              }
              idx++;
            }
            interleaved.push(...orphans);
            shuffled = interleaved.length ? interleaved : fisherYates(items.slice());
            try {
              const first3 = shuffled.slice(0, 3).map((li) => ({
                id: li.getAttribute('data-product-id'),
                h: li.getAttribute('data-collection-handle') || ''
              }));
              console.log(DBG, 'mode=round-robin first3=' + JSON.stringify(first3));
            } catch (_e) { /* noop */ }
          } else {
            shuffled = fisherYates(items.slice());
            try {
              const first3 = shuffled.slice(0, 3).map((li) => li.getAttribute('data-product-id'));
              console.log(DBG, 'mode=fisher-yates first3=' + JSON.stringify(first3),
                'reason=fairRotation=' + fairRotation + ',orderLen=' + collectionOrder.length);
            } catch (_e) { /* noop */ }
          }
        } catch (err) {
          // Qualquer erro no round-robin -> Fisher-Yates puro (preserva random).
          if (window.console && console.warn) {
            console.warn('[cart-upsell] round-robin fallback to fisher-yates:', err);
          }
          shuffled = fisherYates(items.slice());
        }
        upsellShuffleOrder = shuffled.map((li) => li.getAttribute('data-product-id'));
      } else {
        try {
          console.log('[cu-rotation]', 'reused-existing-order length=' + upsellShuffleOrder.length,
            'first3=' + JSON.stringify(upsellShuffleOrder.slice(0, 3)));
        } catch (_e) { /* noop */ }
      }

      const visibleCount = Math.max(
        1,
        parseInt(list.getAttribute('data-upsell-visible-count') || '4', 10)
      );

      const byId = new Map(items.map((li) => [li.getAttribute('data-product-id'), li]));
      const frag = document.createDocumentFragment();
      let placed = 0;

      // Reaplica ordem persistida: itera upsellShuffleOrder e move LIs.
      upsellShuffleOrder.forEach((pid) => {
        const li = byId.get(pid);
        if (!li) return;
        if (placed < visibleCount) li.removeAttribute('data-shuffle-hidden');
        else li.setAttribute('data-shuffle-hidden', 'true');
        frag.appendChild(li);
        byId.delete(pid);
        placed++;
      });

      // Produtos novos (que nao estavam no pool original) vao no fim.
      byId.forEach((li) => {
        if (placed < visibleCount) li.removeAttribute('data-shuffle-hidden');
        else li.setAttribute('data-shuffle-hidden', 'true');
        frag.appendChild(li);
        placed++;
      });

      list.appendChild(frag);
      list.setAttribute('data-shuffle-ready', '');
    });
  }
  // Expor pra debug e pra outros scripts (ex: gift-cart-guard) reaplicarem.
  window.shuffleUpsellPool = shuffleUpsellPool;

  // DEBUG HELPER (2026-05-20): coleta estado do upsell pra diagnostico.
  // Uso no console: cyDebugUpsell()
  window.cyDebugUpsell = function () {
    var lists = document.querySelectorAll('.cart-drawer-upsell-list[data-upsell-random="true"]');
    var out = [];
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var allLis = list.querySelectorAll(':scope > li[data-product-id]');
      var handles = {};
      for (var j = 0; j < allLis.length; j++) {
        var h = allLis[j].getAttribute('data-collection-handle') || '__EMPTY__';
        handles[h] = (handles[h] || 0) + 1;
      }
      var visibles = [];
      for (var k = 0; k < allLis.length; k++) {
        if (!allLis[k].hasAttribute('data-shuffle-hidden')) {
          var titleEl = allLis[k].querySelector('.cart-drawer-upsell-list-item-title');
          visibles.push({
            id: allLis[k].getAttribute('data-product-id'),
            h: allLis[k].getAttribute('data-collection-handle'),
            title: titleEl ? titleEl.textContent.trim().slice(0, 30) : ''
          });
        }
      }
      out.push({
        index: i,
        parent: (list.closest('[id]') && list.closest('[id]').id) || '?',
        orderAttr: list.getAttribute('data-upsell-collection-order'),
        fairRot: list.getAttribute('data-upsell-fair-rotation'),
        collCount: list.getAttribute('data-upsell-collections-count'),
        visibleCount: list.getAttribute('data-upsell-visible-count'),
        totalLis: allLis.length,
        handlesDistribution: handles,
        visibleProducts: visibles
      });
    }
    var json = JSON.stringify(out, null, 2);
    console.log(json);
    return out;
  };

  // Expor globalmente para o outro script usar
  window.setUpsellProcessing = function(value) {
    isUpsellProcessing = value;
    if (value) {
      // Cancela qualquer refresh já agendado: mutações que aconteceram
      // antes da supressão começar (de outros scripts) deixariam um
      // setTimeout ativo que dispararia ~500ms depois e provocaria
      // flicker do cross-sell.
      if (drawerTimer) { clearTimeout(drawerTimer); drawerTimer = null; }
      if (pageTimer)   { clearTimeout(pageTimer);   pageTimer   = null; }
    }
  };

  // Idempotente: cria/recria o wrapper visível e SEMPRE re-sincroniza o clone
  // do upsell a partir do `#cart-drawer-upsell-wrapper` original (que vive
  // FORA de <cart-drawer> e nao e destruido pelos re-renders do Dawn).
  // Antes era no-op se o wrapper existisse — isso fazia o clone ficar stale
  // (ou simplesmente sumir) entre o re-render do Dawn e o fetch debounced.
  function ensureUpsellClone() {
    const cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
    if (!cartDrawerItems) return
    if (cartDrawerItems.classList.contains('is-empty')) return

    let wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
    if (!wrapper) {
      wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)
    }

    const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
    if (!upsells) return

    // Remove clone antigo (se houver) e injeta fresh do original.
    // PERF: skip se o HTML do clone atual ja bate com o original.
    // CYGNUSS 2026-05-06 v16 (fix flicker): cache check trocado de length-compare
    // para outerHTML semantica. Antes: existingClone.outerHTML.length ===
    // upsells.innerHTML.length — sempre falhava porque innerHTML inclui o
    // whitespace/newline entre o wrapper e o #cart-drawer-upsell, mas
    // existingClone.outerHTML nao. Resultado: a cada observer trigger (~250ms)
    // o clone era removido + re-injetado e os <img loading="lazy"> piscavam.
    const existingClone = wrapper.querySelector('#cart-drawer-upsell')
    const sourceUpsell = upsells.querySelector('#cart-drawer-upsell')
    const sourceHTML = upsells.innerHTML
    if (existingClone && sourceUpsell && existingClone.outerHTML === sourceUpsell.outerHTML) {
      return
    }
    if (existingClone) existingClone.remove()
    wrapper.insertAdjacentHTML('beforeend', sourceHTML)

    // PERF 2026-05-27 (INSTR #009): strip <script id="cu-variants-N"> do clone.
    // cuGetVariants (cart-upsell.liquid:1999) usa document.getElementById global,
    // que sempre retorna o original (fora do drawer). Scripts no clone sao redundantes
    // (~555KB DOM). Original permanece intacto fora de <cart-drawer>.
    wrapper.querySelectorAll('script[id^="cu-variants-"]').forEach(s => s.remove())

    // Se o upsell veio sem itens, remove o card todo do clone.
    const cloneList = wrapper.querySelector('.cart-drawer-upsell-list li')
    if (!cloneList) {
      const cdu = wrapper.querySelector('#cart-drawer-upsell')
      if (cdu) cdu.remove()
    }
  }
  // Backwards-compat: alguns lugares ainda chamam insertSectionCartDrawer.
  function insertSectionCartDrawer() { ensureUpsellClone() }

  // Boot: 1) embaralha a fonte (#cart-drawer-upsell-wrapper) 2) clona pro drawer.
  // Ordem importa: ensureUpsellClone copia innerHTML da fonte, entao a fonte
  // precisa estar embaralhada ANTES da copia, senao o clone fica em ordem original.
  shuffleUpsellPool(document.querySelector('#cart-drawer-upsell-wrapper'));
  insertSectionCartDrawer()
  // Embaralha o clone tambem (defensivo: se ensureUpsellClone foi early-exit,
  // o clone pode ja existir desde uma navegacao anterior sem shuffle aplicado).
  shuffleUpsellPool(document.querySelector('#CartDrawer .cart-drawer-items-wrapper'));

  // Expor ensureUpsellClone globalmente. gift-cart-guard.applySections precisa
  // re-sincronizar o clone explicitamente apos sobrescrever cart-drawer-items
  // (ele suprime o MutationObserver durante a escrita pra evitar re-fetch em
  // cascata, entao o observer nao redisparariia ensureUpsellClone naturalmente).
  // Sem isso, o clone ficava stale apos remove de brinde / pageshow restore,
  // resultando em buttons "Adicionar"/"Trocar" sem handlers ativos visualmente.
  window.ensureUpsellClone = ensureUpsellClone;

  window.onChangeKsUpsellVariantSelector = function(select, event) {
    event.preventDefault()
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg

    if (imgSrc) {
      const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
      img.src = imgSrc
    }
  }

  // PERF: helper pra rodar tarefa em idle callback (com fallback p/ rAF)
  // — evita bloquear o frame imediatamente após a mutação do DOM.
  const idle = (cb) => (window.requestIdleCallback
    ? requestIdleCallback(cb, { timeout: 200 })
    : requestAnimationFrame(cb));

  // PERF: filtra mutações irrelevantes. Só nos importam mudanças que
  // afetam o conteúdo dos line-items ou que removem o upsell-wrapper.
  // Isso elimina ~70% dos disparos do observer (mudanças em aria-expanded,
  // hidden, classes no overlay, etc. dispararam re-fetch desnecessário).
  function isRelevantDrawerMutation(mutations) {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;
      const target = m.target;
      if (!target || !target.closest) continue;
      // PERF 2026-05-05: filter restringido — antes incluia .drawer__inner
      // (cobre footer/coupon/progress) e qualquer descendant de #CartDrawer.
      // Agora só estruturas que de fato contêm OU são pai direto do upsell clone.
      if (target.closest('cart-drawer-items, .cart-drawer-items-wrapper')) {
        return true;
      }
      // Mutações em #CartDrawer só importam se envolveram nodes que continham o upsell.
      if (m.target?.id === 'CartDrawer' && (m.removedNodes.length || m.addedNodes.length)) {
        const involvesUpsell = [...m.removedNodes, ...m.addedNodes].some(n =>
          n.nodeType === 1 && (n.id === 'cart-drawer-upsell' || n.querySelector?.('#cart-drawer-upsell'))
        );
        if (involvesUpsell) return true;
      }
    }
    return false;
  }

  function isRelevantPageMutation(mutations) {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;
      if (m.removedNodes.length || m.addedNodes.length) return true;
    }
    return false;
  }

  // PERF: Section Rendering API em vez de fetch da página inteira.
  // window.location.href retorna o HTML completo da página atual
  // (50-300KB com todas as sections), enquanto ?section_id=cart-drawer
  // retorna apenas a section do cart-drawer (~10-30KB) com cache HTTP
  // mais agressivo do Shopify. Ganho típico: 200-800ms por refresh.
  // /cart é leve e sempre disponível, garantindo consistência da response.
  const SECTION_URL = '/cart?section_id=cart-drawer';

  async function fetchUpsellWrapper() {
    const response = await fetch(SECTION_URL, { credentials: 'same-origin' });
    if (!response.ok) return null;
    const text = await response.text();
    // Section Rendering API retorna apenas o markup da section, sem
    // <html>/<head>. DOMParser ainda funciona pq embrulha em <body>.
    const newDocument = new DOMParser().parseFromString(text, 'text/html');
    return newDocument.querySelector('#cart-drawer-upsell-wrapper');
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer')
    if (!element) return

    const observer = new MutationObserver((mutations) => {
      if (isUpsellProcessing) return;
      if (!isRelevantDrawerMutation(mutations)) return;

      // CYGNUSS 2026-05-19 (fix flicker editor): se qualquer variant-card
      // estiver com editor aberto (.is-open), aborta re-render. O re-fetch
      // substitui o wrapper inteiro por sourceHTML fresco — onde o editor
      // volta com [hidden] do Liquid. Resultado: usuario abre editor, ve
      // 700ms depois ele "fechar sozinho" (na verdade foi swapado pra copia
      // fresca). Adiar o re-fetch ate o editor fechar evita o flicker.
      if (document.querySelector('.variant-card.is-open')) {
        return;
      }

      // CRITICO: o insertAdjacentHTML dentro de ensureUpsellClone gera mutacoes
      // childList no proprio wrapper observado. Sem esse guard, o observer
      // dispara de novo apos ensureUpsellClone, chama de novo, e cai em loop
      // infinito (~700+ iter/seg). O bug ficou visivel quando o HTML do upsell
      // contem <product-form> que joga no constructor (this.submitButton=null),
      // mas o loop existia mesmo sem o throw — apenas sem stack trace ruidoso.
      // Solucao: marcar isUpsellProcessing antes da mutacao sincrona e limpar
      // via setTimeout(0) — observers sao microtasks, setTimeout e macrotask,
      // entao a callback do observer auto-induzido roda enquanto a flag ainda
      // esta true e e descartada pelo `if (isUpsellProcessing) return` acima.
      isUpsellProcessing = true;
      try { ensureUpsellClone(); }
      catch (e) { console.warn('[cart-upsell] ensureClone falhou', e); }
      setTimeout(function(){ isUpsellProcessing = false; }, 0);

      if (drawerTimer) clearTimeout(drawerTimer)

      // PERF: 250ms é suficiente pra debounce de mutações em rajada
      // (cart-drawer.js renderContents → forEach sections). 500ms era
      // conservador demais e adicionava latência visível ao usuário.
      drawerTimer = setTimeout(() => {
        if (isUpsellProcessing) return;
        // Re-check no momento do timeout — usuario pode ter aberto editor
        // nos 250ms de debounce.
        if (document.querySelector('.variant-card.is-open')) {
          drawerTimer = null;
          return;
        }
        idle(async () => {
          if (isUpsellProcessing) return;
          if (document.querySelector('.variant-card.is-open')) {
            drawerTimer = null;
            return;
          }

          const newWrapper = await fetchUpsellWrapper();
          if (!newWrapper) { drawerTimer = null; return; }

          // PERF: skip replaceWith se HTML é idêntico ao último — evita
          // reflow/repaint custoso quando a mutação não mudou o upsell.
          const newHTML = newWrapper.innerHTML;
          if (newHTML === lastDrawerUpsellHTML) {
            // Mesmo se o original nao mudou, garante que o clone esta sincronizado
            // (caso ainda nao tenha sido restaurado).
            // CYGNUSS 2026-05-06 v16 (fix flicker): proteger com isUpsellProcessing.
            // Sem o flag, a mutacao do ensureUpsellClone redispara o observer,
            // que reagenda novo fetch em 250ms -> loop infinito ate fechar drawer.
            isUpsellProcessing = true;
            try { ensureUpsellClone(); }
            finally { setTimeout(function(){ isUpsellProcessing = false; }, 0); }
            drawerTimer = null;
            return;
          }
          lastDrawerUpsellHTML = newHTML;

          const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
          if (currentWrapper) {
            currentWrapper.replaceWith(newWrapper);
          }

          // RANDOM CROSSELL: o newWrapper veio fresh do servidor, em ordem
          // original da colecao. Reaplica a ordem persistida ANTES do clone
          // copiar — senao o clone fica em ordem diferente do source.
          shuffleUpsellPool(document.querySelector('#cart-drawer-upsell-wrapper'));

          // Re-sincroniza o clone com os dados frescos do original.
          // CYGNUSS 2026-05-06 v16 (fix flicker): mesma proteccao do branch acima.
          isUpsellProcessing = true;
          try {
            ensureUpsellClone();
            shuffleUpsellPool(document.querySelector('#CartDrawer .cart-drawer-items-wrapper'));
          } finally {
            setTimeout(function(){ isUpsellProcessing = false; }, 0);
          }
          drawerTimer = null;
        });
      }, 250)
    })

    observer.observe(element, {
      // PERF: removido `attributes: true` — flips de aria-expanded/hidden
      // disparavam re-fetch desnecessário. Só nos importa childList.
      attributes: false,
      childList: true,
      subtree: true
    });

    // CYGNUSS 2026-05-05 v17: observer dedicado pro `class` do cart-drawer.
    // Bug: as vezes o upsell nao aparece quando o drawer abre — a primeira
    // abertura nao gera mutacao no childList se o cart ja estava renderizado
    // antes (e.g., ao recarregar a pagina com cart populado). O observer
    // principal so reage a mudanca de items, entao nao re-clona nesse momento.
    // Solucao: observar quando .active e adicionada e forcar ensureUpsellClone.
    let lastActive = element.classList.contains('active');
    const classObserver = new MutationObserver(() => {
      const nowActive = element.classList.contains('active');
      if (nowActive && !lastActive) {
        if (!isUpsellProcessing) {
          isUpsellProcessing = true;
          try { ensureUpsellClone(); }
          catch (e) { console.warn('[cart-upsell] open-hook ensureClone falhou', e); }
          setTimeout(function(){ isUpsellProcessing = false; }, 0);
        }
      }
      lastActive = nowActive;
    });
    classObserver.observe(element, { attributes: true, attributeFilter: ['class'] });
  }
  listenCartDrawer()

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items')
    if (!element) return

    const observer = new MutationObserver((mutations) => {
      if (isUpsellProcessing) return;
      if (!isRelevantPageMutation(mutations)) return;

      if (pageTimer) clearTimeout(pageTimer)

      pageTimer = setTimeout(() => {
        if (isUpsellProcessing) return;
        idle(async () => {
          if (isUpsellProcessing) return;

          const newWrapper = await fetchUpsellWrapper();
          if (!newWrapper) { pageTimer = null; return; }

          const newHTML = newWrapper.innerHTML;
          if (newHTML === lastPageUpsellHTML) { pageTimer = null; return; }
          lastPageUpsellHTML = newHTML;

          const currentWrapper = document.querySelector('#cart-drawer-upsell-wrapper');
          if (currentWrapper) currentWrapper.replaceWith(newWrapper);

          // RANDOM CROSSELL: reaplica ordem persistida apos re-fetch.
          shuffleUpsellPool(document.querySelector('#cart-drawer-upsell-wrapper'));

          // QA#1: insertSectionCartPage() never existed in this IIFE — guarding
          // protects against silent ReferenceError that detached upsell on /cart.
          if (typeof insertSectionCartPage === 'function') insertSectionCartPage()
          pageTimer = null;
        });
      }, 250)
    })

    observer.observe(element, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
  listenCartPage()
})();
